export default function TrifectaDefense() {
  const systems = [
    {
      title: 'Entity Structuring',
      subtitle: 'The Fortress',
      description: 'The right business entity is your first line of defense. LLC, S-Corp, or a combination — we build the structure that separates personal assets from business liability and puts you in the most favorable tax position.',
      features: [
        'Business entity formation and setup',
        'Asset separation and liability protection',
        'S-Corp election and tax optimization',
        'Full state filings, EIN, operating docs'
      ],
      icon: 'ri-shield-line',
      number: '01'
    },
    {
      title: 'Tax Strategy',
      subtitle: 'The War Chest',
      description: "A proper tax plan isn't about filing — it's about structuring. We review your situation, build your Trifecta diagram, and implement strategies that reduce what you owe. Every dollar you keep is a dollar in your War Chest.",
      features: [
        'Prior-year tax return review',
        'Trifecta business-assets-estate diagram',
        'Custom tax and legal implementation plan',
        'Self-directed IRA and Solo 401(k) setup'
      ],
      icon: 'ri-safe-line',
      number: '02'
    },
    {
      title: 'Estate Planning',
      subtitle: 'The Lockdown',
      description: "Revocable living trust, powers of attorney, advance directives — this keeps the courts out of your family's business. Assets transfer instantly, privately, exactly how you want.",
      features: [
        'Revocable living trust and will',
        'Powers of attorney (financial and healthcare)',
        'Advance directives and living wills',
        'Probate avoidance and instant asset transfer'
      ],
      icon: 'ri-lock-2-line',
      number: '03'
    }
  ];

  return (
    <section id="how-it-works" className="py-12 md:py-20 bg-[#121212]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-black text-center mb-4 tracking-tight leading-tight">
          YOUR TRIFECTA DEFENSE SYSTEM
        </h2>
        <p className="text-base sm:text-lg md:text-xl text-gray-400 text-center max-w-4xl mx-auto mb-10 sm:mb-14 px-2">
          A comprehensive tax and legal strategy that brings your business, your assets, and your estate under one coordinated plan. Built by attorneys. Deployed for entrepreneurs.
        </p>

        <div className="space-y-6">
          {systems.map((system, index) => (
            <div
              key={index}
              className="flex flex-col lg:flex-row gap-0 items-stretch bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl overflow-hidden hover:border-[#dc2626] transition-all group"
            >
              {/* Accent panel */}
              <div className="lg:w-56 flex-shrink-0 flex flex-row lg:flex-col items-center justify-start lg:justify-center gap-4 bg-[#141414] border-b lg:border-b-0 lg:border-r border-[#2a2a2a] group-hover:border-[#dc2626] transition-all p-5 sm:p-8">
                <span className="text-4xl sm:text-5xl font-black text-[#dc2626]/20 leading-none">{system.number}</span>
                <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-[#dc2626]/10 rounded-lg group-hover:bg-[#dc2626]/20 transition-colors flex-shrink-0">
                  <i className={`${system.icon} text-xl sm:text-2xl text-[#dc2626]`}></i>
                </div>
                <div className="text-left lg:text-center">
                  <p className="text-[#dc2626] font-black text-xs sm:text-sm tracking-widest uppercase">{system.subtitle}</p>
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 p-6 sm:p-8 md:p-10">
                <h2 className="text-xl sm:text-2xl md:text-3xl font-black text-white mb-3 tracking-tight">
                  {system.title}
                </h2>
                <p className="text-gray-400 mb-6 leading-relaxed text-sm md:text-base max-w-2xl">
                  {system.description}
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {system.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-[#dc2626] text-base mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-300 text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}